import styled from 'styled-components';

import { MediaQuery } from '../../../../../constants/Styles';

export const ButtonWrapper = styled.div`
  margin-left: ${({ hasMargin }) => hasMargin && '10px'};

  a {
    margin-right: 10px;
    margin-left: ${({ isEvent }) => isEvent && '10px'};
  }

  display: ${({ isSearchBarDisplayed, isMobile }) =>
    isSearchBarDisplayed && isMobile ? 'none' : 'initial'};

  ${MediaQuery.XL_AND_DOWN} {
    a {
      margin-right: 5px;
    }
  }

  ${MediaQuery.L_AND_DOWN} {
    margin-top: 15px;
  }

  ${MediaQuery.M_AND_DOWN} {
    a {
      margin-bottom: 5px;
    }
  }
`;
